import { NgZone } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CookieServiceService } from '../cookie-service.service';
import { HelperService } from '../helper.service';
import { UtilisService } from '../utilis.service';

@Component({
  selector: 'app-fed-epoint-url',
  templateUrl: './fed-epoint-url.component.html',
  styleUrls: ['./fed-epoint-url.component.scss']
})
export class FedEPointURLComponent implements OnInit {
  solid: any;
  branchname: any;
  accountNumber: string;
  response: any;
  IssueArr: any = [];
  constructor(public helperService: HelperService, private router: Router, private ngZone: NgZone,
    private utilService: UtilisService,
    private spinner: NgxSpinnerService,
    private toast: ToastrService,
    private cookieService: CookieServiceService, private route: ActivatedRoute) {

  }

  funcFedEpoint(msg) {
    this.helperService.makeGetRequest("/getKey").subscribe(
      res => {
        this.utilService.setData(res.enc_key);
        this.IssueArr = ({
          message: msg,
          key  :this.utilService.getData()
        })
        this.spinner.show();
        this.helperService.makePostRequest(this.IssueArr, "/getEpoint").subscribe(res => {
          this.spinner.hide();
          if (this.utilService.DecryptdataV1(res.status, this.utilService.getData()) === "S") {
            this.solid = this.utilService.DecryptdataV1(res.solid, this.utilService.getData());
            this.branchname = this.utilService.DecryptdataV1(res.branchname, this.utilService.getData());
            this.accountNumber = this.utilService.DecryptdataV1(res.account_no, this.utilService.getData());
            this.utilService.setData(res);            
            this.cookieService.setJWTCookie(res.token);          
            this.utilService.setIsReloadedAfterLogin(false);
            this.router.navigateByUrl('/Home', {
              state:
              {
                accountNumber: this.accountNumber, solid: this.solid, branchname: this.branchname
              }
            });

          }
          else {
            this.response = this.utilService.DecryptdataV1(res.branchname, this.utilService.getData());
          }
        }, e => {
          console.log(e);
        });
      }, err => {
        console.log(err);
      });

  }

  getKey() {
    try {
      this.helperService.makeGetRequest("/getKey").subscribe.toPromise((
        (res => {
          this.utilService.setData(res.enc_key);
        })));
    }
    catch (Error) {
      this.spinner.hide();
      this.toast.error("Unable To Load Captcha. Please contact Administrator", "", {
        positionClass: 'toast-bottom-right'
      });
    }
  }
  ngOnInit(): void {
    this.route.queryParamMap.subscribe(queryParams => {
      //alert(decodeURIComponent(queryParams.get("id").replace(/ /g,"+")));
      this.funcFedEpoint(decodeURIComponent(queryParams.get("id").replace(/ /g, "+")));
    })
  }

}
